const transformValidTimeInput = (value, inputField = 'm') => {
  if (inputField === 'h') {
    if (value > 99) return 99;
    if (value <= 0) return 0;
    return value;
  }
  if (value > 60) return 59;
  if (value <= 0) return 0;
  return value;
};

const convertTimeToMillis = (value, time) => {
  if (time === 'h') return value * 60 * 60 * 1000;
  if (time === 'm') return value * 60 * 1000;
  return value * 1000;
};

export const parseTime = (timeInMillis) => {
  const seconds = Math.round((timeInMillis / 1000) % 60);
  const minutes = Math.floor((timeInMillis / (1000 * 60)) % 60);
  const hours = Math.floor(timeInMillis / (1000 * 60 * 60));

  const hoursString = hours <= 0 ? '' : `${hours}h `;
  const minutesString = hours <= 0 && minutes <= 0 ? '' : `${minutes}m `;
  const secondsString =
    hours <= 0 && minutes <= 0 && seconds <= 0 ? '' : `${seconds}s`;

  return {
    hours,
    minutes,
    seconds,
    friendlyTimeFormat: `${hoursString}${minutesString}${secondsString}`,
  };
};

export const handleMinuteButton = (currentTime, value) => {
  const maxHoursInMilliseconds = convertTimeToMillis(99, 'h');
  const maxMinutesInMilliseconds = convertTimeToMillis(59, 'm');
  const maxSecondsInMilliseconds = convertTimeToMillis(59, 's');
  const maxCurrentTime =
    maxHoursInMilliseconds +
    maxMinutesInMilliseconds +
    maxSecondsInMilliseconds;

  const valueInMillis = convertTimeToMillis(value, 'm');

  if (currentTime + valueInMillis >= maxCurrentTime) return maxCurrentTime;
  if (currentTime <= 0 && valueInMillis < 0) return 0;
  return currentTime + valueInMillis;
};

export const convertToMilliseconds = (hours, minutes, seconds) => {
  const parsedHours = Number.parseInt(hours, 10);
  const parsedMinutes = Number.parseInt(minutes, 10);
  const parsedSeconds = Number.parseInt(seconds, 10);

  if (
    Number.isNaN(parsedHours) ||
    Number.isNaN(parsedMinutes) ||
    Number.isNaN(parsedSeconds)
  ) {
    return;
  }

  const checkedHours = transformValidTimeInput(parsedHours, 'h');
  const checkedMinutes = transformValidTimeInput(parsedMinutes, 'm');
  const checkedSeconds = transformValidTimeInput(parsedSeconds, 's');

  return (
    convertTimeToMillis(checkedHours, 'h') +
    convertTimeToMillis(checkedMinutes, 'm') +
    convertTimeToMillis(checkedSeconds, 's')
  );
};
